import { FiMoreHorizontal } from "react-icons/fi";
import React from "react";

type SessionData = {
  sessionId: string | null;
  sessionTitle: string | null;
};

const PopOver = ({
  sessionId,
  sessionTitle,
  showMoreButton,
  setActiveRenameModalHandler,
  setActiveDeleteModalHandler,
  setRenameModalPropsHandler,
}: {
  sessionId: string;
  sessionTitle: string;
  showMoreButton: boolean;
  setActiveRenameModalHandler: (prop: boolean) => void;
  setActiveDeleteModalHandler: (prop: boolean) => void;
  setRenameModalPropsHandler: (prop: SessionData) => void;
}) => {
  const popoverId = `popover-${sessionId}`;
  const anchorName = `--anchor-${sessionId}`;

  return (
    <>
      {/* More Button */}
      <button
        className={`btn btn-ghost btn-xs p-1 transition-all duration-200 ${
          showMoreButton ? 'opacity-100' : 'opacity-0'
        } hover:bg-base-300`}
        popoverTarget={popoverId}
        style={{ anchorName } as React.CSSProperties}
      >
        <FiMoreHorizontal size={16} />
      </button>

      {/* Dropdown Menu */}
      <ul
        className="dropdown menu w-52 rounded-box bg-base-100 shadow-sm"
        popover="auto"
        id={popoverId}
        style={{ positionAnchor: anchorName } as React.CSSProperties}
      >
        <li>
          <a
            onClick={() => {
              setActiveRenameModalHandler(true);
              setRenameModalPropsHandler({
                sessionId: sessionId,
                sessionTitle: sessionTitle,
              });
            }}
          >
            Rename
          </a>
        </li>
        <li>
          <a
            className="text-error hover:bg-error hover:text-error-content"
            onClick={() => {
              setActiveDeleteModalHandler(true);
              setRenameModalPropsHandler({
                sessionId: sessionId,
                sessionTitle: sessionTitle,
              });
            }}
          >
            Delete
          </a>
        </li>
      </ul>
    </>
  );
};

export default PopOver;
